import { IonButton } from "@ionic/react";

export function StorageConsentNotice({ onAccept }: { onAccept: () => void }) {
  return (
    <section className="consent-notice" aria-label="Storage notice">
      <p>Pyeah saves your tracker and currency preference in this browser.</p>
      <IonButton size="small" onClick={onAccept}>
        OK
      </IonButton>
    </section>
  );
}
